import { Injectable } from '@angular/core';
import 'firebase/analytics';
import { analytics } from 'firebase/app';
import { ulid } from 'ulid';
import { AnalyticsEvent } from './event/analytics-event';
import { SessionAction, SessionEvent } from './event/session-event';
import { UserProperty } from './user-property';

export enum SessionType {
  RESERVE_FLOW = 'reserve_flow',
  SIGN_UP = 'sign_up',
}

export enum SessionDeleteReason {
  TASK_COMPLETED = 'task_completed',
  TASK_CANCELED = 'task_canceled',
  TASK_FAILURE = 'task_failure',
  APP_TERMINATE = 'task_terminate',
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private analytics: analytics.Analytics;
  private sessions: Map<SessionType, string> = new Map();
  constructor() {
    this.analytics = analytics();
  }

  setCurrentScreen(screenName: string) {
    this.analytics.setCurrentScreen(screenName);
  }

  logEvent(event: AnalyticsEvent) {
    const params = [...event.params].reduce(
      (l, [k, v]) => Object.assign(l, { [k]: v }),
      {},
    );
    this.analytics.logEvent(event.eventName, params);
  }

  createSession(type: SessionType) {
    const uuid = ulid();
    this.sessions.set(type, uuid);
    const action = new SessionAction();
    this.logEvent(new SessionEvent(action.created(), type, uuid));
  }

  deleteSession(type: SessionType, reason: SessionDeleteReason) {
    const toDelete = this.sessions.get(type);
    if (toDelete) {
      this.sessions.delete(type);
      const action = new SessionAction();
      this.logEvent(new SessionEvent(action.deleted(reason), type, toDelete));
    } else {
      return;
    }
  }
  setUserId(userId: string) {
    this.analytics.setUserId(userId);
  }
  setUserProperty(userProperty: UserProperty) {
    this.analytics.setUserProperties(userProperty.params);
  }
}
